// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"LocationCard_pattern-gradient__tLuiu","card":"LocationCard_card__JUzWu"};